<template>
  <router-link class="project-card col-md-3 mb-4" :to="link">
    <div class="card card-background align-items-start" :class="{
      'card-background-mask-dark': !isNew,
      'card-background-mask-primary': isNew
    }">
      <div class="d-block w-100">
        <div class="full-background cursor-pointer " :style="{
          background: 'url(' + image + ')'
        }">
        </div>
        <div class="card-body">
          <div class="float-end" v-if="isNew">
            <i class="material-icons text-white" style="font-size:60px;">
              add_circle_outline
            </i>
          </div>

          <h5 class="text-white mb-0">
            {{ title }}
          </h5>
          <p class="text-white text-sm">
            {{ subTitle }}
          </p>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { parseDateTimeRange } from '@/helpers/parsers';
import { getDateString } from '@/helpers/datetime'

export default {
  name: 'ProjectCard',

  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      default: '&nbsp;'
    },
    projectId: {
      type: Number,
      default: 0,
    },
    image: {
      type: String,
      required: true,
    },
    isNew: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    link() {
      return this.isNew
        ? {
          name: 'new-project',
          params: {
            parentId: this.projectId
          }
        }

        : {
          name: 'project-overview',
          params: {
            projectId: this.projectId,
          },
        };
    },
    dateCreateString() { return getDateString(new Date(this.publishDateTime)) },
    datePinnedString() {
      return this.pinnedDate instanceof String && this.pinnedDate !== ''
        ? getDateString(new Date(this.this.pinnedDate))
        : ''
    }
  },

  methods: {
    parseDateTimeRange,
  },
};
</script>

<style scoped lang="scss">
.card {
  min-height: 100%;
}

.news-card {
  &:nth-child(n + 5) {
    margin-top: var(--bs-gutter-x);
  }

  &__image {
    object-fit: cover;

    &-container {
      height: 200px;
    }
  }

  &__description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  &__reactions p {
    margin-bottom: 0;
  }
}
</style>
